import { TimeSpan } from "../lib/timeSpan";

export namespace TimeSpanHelper {
    export const TicksPerMicrosecond: number = 10;
    export const TicksPerMillisecond: number = TicksPerMicrosecond * 1000;
    export const TicksPerSecond: number = TicksPerMillisecond * 1000;   // 10,000,000
    export const TicksPerMinute: number = TicksPerSecond * 60;         // 600,000,000
    export const TicksPerHour: number = TicksPerMinute * 60;        // 36,000,000,000
    export const TicksPerDay: number = TicksPerHour * 24;          // 864,000,000,000

    export function FromDays(value: number): TimeSpan {
        const result = new TimeSpan();
        result.days = value;
        return result;
    }
}


